import type { Article } from "src/api";

export function getArticleUnitPrice(
	article: Article,
	vatEnabled: boolean,
): number {
	return vatEnabled ? article.priceWithVat : article.priceWithoutVat;
}

export function getArticleTotalPrice(
	article: Article,
	vatEnabled: boolean,
): number {
	return getArticleUnitPrice(article, vatEnabled) * article.quantity;
}

export function getCartTotalPrice(
	articles: Article[],
	vatEnabled: boolean,
): number {
	return articles.reduce(
		(total, article) => total + getArticleTotalPrice(article, vatEnabled),
		0,
	);
}
